import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × SUZAN AI (BOBO): Bobo-rational elegance
// Linen texture, soft op-fields, trust palette
export function VasarelySuzanaiBoboMode({ brand }: ModeRendererProps) {
  return (
    <g>
      <defs>
        <linearGradient id="suzanbobo-trust1" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#E8F4F8" />
          <stop offset="50%" stopColor="#D8E8F0" />
          <stop offset="100%" stopColor="#C8DCE8" />
        </linearGradient>
        <linearGradient id="suzanbobo-trust2" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#F5F0E8" />
          <stop offset="100%" stopColor="#E8E0D8" />
        </linearGradient>
        <pattern id="suzanbobo-linen" x="0" y="0" width="4" height="4" patternUnits="userSpaceOnUse">
          <line x1="0" y1="0" x2="4" y2="4" stroke="#D8D0C8" strokeWidth="0.3" opacity="0.3" />
          <line x1="4" y1="0" x2="0" y2="4" stroke="#D8D0C8" strokeWidth="0.3" opacity="0.3" />
        </pattern>
        <radialGradient id="suzanbobo-soft">
          <stop offset="0%" stopColor="#B8D8E8" stopOpacity="0.4" />
          <stop offset="100%" stopColor="#D8E8F0" stopOpacity="0" />
        </radialGradient>
      </defs>

      {/* Linen-like background */}
      <rect x="0" y="0" width="794" height="1123" fill="url(#suzanbobo-trust2)" />
      <rect x="0" y="0" width="794" height="1123" fill="url(#suzanbobo-linen)" />

      <g transform="translate(397 540)">
        {/* Soft op-fields */}
        {Array.from({ length: 8 }).map((_, i) => {
          const r = 80 + i * 40;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="url(#suzanbobo-soft)"
              opacity={0.3 - i * 0.03}
            />
          );
        })}

        {/* Trust palette grid */}
        {Array.from({ length: 12 }).map((_, i) =>
          Array.from({ length: 16 }).map((_, j) => {
            const x = (i - 5.5) * 60;
            const y = (j - 7.5) * 65;
            
            return (
              <rect
                key={`${i}-${j}`}
                x={x - 28}
                y={y - 30}
                width="56"
                height="60"
                fill="none"
                stroke="#B8C8D8"
                strokeWidth="1"
                opacity="0.25"
              />
            );
          })
        )}

        {/* Ethical intelligence circles */}
        {Array.from({ length: 10 }).map((_, i) => {
          const r = 60 + i * 26;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke="#A8B8C8"
              strokeWidth="1.5"
              opacity={0.3 - i * 0.025}
            />
          );
        })}

        {/* Bobo-rational geometry */}
        {[
          { x: -180, y: -240, w: 140, h: 180, angle: 2 },
          { x: 40, y: -220, w: 160, h: 160, angle: -3 },
          { x: -160, y: 40, w: 150, h: 200, angle: 1 },
          { x: 60, y: 60, w: 140, h: 180, angle: -2 },
        ].map((field, i) => (
          <rect
            key={i}
            x={field.x}
            y={field.y}
            width={field.w}
            height={field.h}
            fill="url(#suzanbobo-trust1)"
            opacity="0.3"
            stroke="#A8B8C8"
            strokeWidth="1"
            transform={`rotate(${field.angle} ${field.x + field.w / 2} ${field.y + field.h / 2})`}
          />
        ))}

        {/* Everyday life geometry */}
        {Array.from({ length: 8 }).map((_, i) => {
          const angle = (i * Math.PI) / 4;
          return (
            <line
              key={i}
              x1="0"
              y1="0"
              x2={Math.cos(angle) * 260}
              y2={Math.sin(angle) * 260}
              stroke="#B8C8D8"
              strokeWidth="1"
              opacity="0.2"
            />
          );
        })}

        {/* Central SUZAN AI emblem */}
        <rect x="-100" y="-100" width="200" height="200" fill="url(#suzanbobo-trust1)" opacity="0.4" />
        <rect x="-90" y="-90" width="180" height="180" fill="none" stroke="#A8B8C8" strokeWidth="2" />
        <rect x="-80" y="-80" width="160" height="160" fill="none" stroke="#B8C8D8" strokeWidth="1" />

        {/* Nested trust circles */}
        <circle cx="0" cy="0" r="70" fill="none" stroke="#98A8B8" strokeWidth="2" opacity="0.5" />
        <circle cx="0" cy="0" r="55" fill="none" stroke="#A8B8C8" strokeWidth="1.5" opacity="0.4" />
        <circle cx="0" cy="0" r="40" fill="none" stroke="#B8C8D8" strokeWidth="1" opacity="0.3" />

        {/* AI nodes */}
        {[0, 90, 180, 270].map((angle) => {
          const rad = (angle * Math.PI) / 180;
          const r = 60;
          
          return (
            <circle
              key={angle}
              cx={Math.cos(rad) * r}
              cy={Math.sin(rad) * r}
              r="8"
              fill="#A8B8C8"
              opacity="0.6"
            />
          );
        })}

        <text
          x="0"
          y="-5"
          fontFamily="sans-serif"
          fontSize="16"
          fill="#88A8C8"
          textAnchor="middle"
          fontWeight="300"
          letterSpacing="3"
        >
          SUZAN
        </text>
        <text
          x="0"
          y="15"
          fontFamily="sans-serif"
          fontSize="12"
          fill="#98B8D8"
          textAnchor="middle"
          fontWeight="300"
          letterSpacing="2"
        >
          AI BOBO
        </text>
      </g>

      {/* Ethical everyday life */}
      <text x="397" y="1010" textAnchor="middle" fontFamily="sans-serif" fontSize="10" fill="#A8B8C8" letterSpacing="2">
        intelligence éthique du quotidien
      </text>
    </g>
  );
}
